/**
 * DM module route definitions.
 *
 * Exports lazy-loaded page components and route paths for the
 * Document Management module. Consumed by the dynamic module route
 * loader in routes/index.tsx via import.meta.glob.
 *
 * Cross-References:
 *   - FR-DM-001: Document CRUD
 *   - FR-DM-004: Approval workflow
 *   - Sprint DM1: Document Management Foundation
 */
import { lazy } from 'react';

const DocumentList = lazy(() => import('./pages/DocumentList'));
const DocumentDetail = lazy(() => import('./pages/DocumentDetail'));
const NewDocument = lazy(() => import('./pages/NewDocument'));
const ApprovalQueue = lazy(() => import('./pages/ApprovalQueue'));
// Sprint DM-8 — SetList page retired; per-set panels live on DocumentList.
const SetSettings = lazy(() => import('./pages/SetSettings'));
const MyPendingAcks = lazy(() => import('./pages/MyPendingAcks'));
const ComplianceReport = lazy(() => import('./pages/ComplianceReport'));

export const slug = 'dm';

export const routes = [
  { path: 'documents', element: DocumentList },
  // Sprint DM-5 TKT-2 — register before :id so /documents/new is matched first.
  { path: 'documents/new', element: NewDocument },
  { path: 'documents/:id', element: DocumentDetail },
  { path: 'approvals', element: ApprovalQueue },
  // Sprint DM-6 TKT-4 — Set Settings (general / contributors / approvers).
  // Sprint DM-8 — /sets list page retired; settings still reachable via
  // the cog on the per-set card on the Documents page.
  { path: 'sets/:id/settings', element: SetSettings },
  { path: 'my-acks', element: MyPendingAcks },
  { path: 'compliance', element: ComplianceReport },
];
